import React, { useState, useEffect } from 'react';

const Typewriter = ({ text, delay }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  // Typing logic (remains the same)
  useEffect(() => {
    if (text && currentIndex < text.length) { // Added a check for text to prevent errors if text is initially undefined or null
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);

  // Reset when text prop changes
  useEffect(() => {
    setCurrentText('');
    setCurrentIndex(0);
  }, [text]);

  return (
    <span>
      {currentText.split('').map((char, index) =>
        char === '▣'
          ? <span key={index} style={{ color: 'red' }}>{char}</span>
          : char
      )}
    </span>
  );
};

export default Typewriter;